module.exports = __webpack_public_path__ + "fonts/Avenir-Roman.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/Avenir/Avenir-Roman.ttf
// module id = 3478
// module chunks = 0